<template>
<div>
  <Breadcrumb :title="'Distribution'"></Breadcrumb>
  <DistributionForm :ref="'DistributionForm'"  :DistributionInfo="DistributionJSON" :DistributionModalLabel="modalConfig" @SaveComplete="refreshGrid">
  </DistributionForm>
  <div>
    <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
  </div>
  <div class='btnDiv'>
    <BaseToolBar :config="ToolbarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
  </div>
  <div>
    <BaseGrid :config="GridConfig" :excelExport="excelExport" :mode="'editform'" @EditItem="EditDistribution" :data="DistributionData"  
    @AttachItem="DistributionAttachment"></BaseGrid>
  </div>
  <DistributionDocumentDropoffForm
      ref="distributionDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedDistribution"
    ></DistributionDocumentDropoffForm>
</div>
</template>

<script>
import $ from 'jquery';
import { GridConfig, ToolbarConfig }  from "./DistributionConfig.js";
import BaseModelDistribution from "@/models/BaseModelDistribution.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import DistributionForm from "@/components/forms/DistributionForm.vue";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import {mapGetters, mapActions, mapState } from 'vuex';
import DistributionDocumentDropoffForm from "@/components/forms/DistributionDocumentDropoffForm.vue"; 
import _ from 'lodash';
import { isNullOrUndefined } from 'util';

export default {
  name: "Distribution",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
    DistributionForm,
    DistributionDocumentDropoffForm
  },
   computed: {
       $eumAuth: function(){
         return this.$root.$eumAuth;
        },
    ...mapGetters("getModule",["withFilter"]),
    ...mapState("postModule",["response"]),
     
  },
  data: function () {
    return {
      GridConfig: GridConfig,
      grid: $("#" + GridConfig.grid.gridId).data("kendoGrid"),
      search: {
        SearchData: "",
      },
      DistributionGridId: "DistributionGrid",
      DistributionMasterData: {},
      ToolbarConfig: ToolbarConfig,
      BaseModelDistribution: BaseModelDistribution,      
      BaseModelUnitClass: BaseModelUnitClass,
      BaseModelProgram: BaseModelProgram,
      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },
      DistributionJSON:  {       
      },
      // DistributionAddJSON: {
      //Id: "",
      // BusinessEvent:"",
      // ProgramId:"",
      // ReceiverId:"",
      // ProgramTitle:"",
      // ReceiverFullName:"",
      // UnitClass:"",
      // UnitType:"",
      // UnitPool:"",
      // Unit:"",
      // TransactionDate:"",                        
      // },
      DistributionEditJSON: {
        Id: "",
        PartnerId:"",
        PartnerPartnerID:"",
        PartnerFullName:"",
        ProgramId:"",
        ProgramProgramID:"",
        ProgramTitle:"",
        DistributionType1:"",
        DistributionType2:"",
        DistributionPartnerType:"",
        DistributionDate:"",  
        DistributionAmount:"",
        Note:""
      },
      DistributionData:[],
      DistributionValuationData:[],
      DistributionInfoData:[],    
      dropdowns: {
        TaxPeriod: { model: "", dataSource: [] },        
      },
      // Document dropoff modal
      docModalConfig: {
        modalName: "Distribution Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      selectedDistribution:{},
     

    }
  },
  mounted() {
    const self = this;
    console.log(self.grid)
    //changes for Toolbar    
    self._loadGridSettings(self.DistributionGridId);
        
    //bind databound event to grid
    const grid = $("#DistributionGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateDistributionMasterData);
    // grid.dataSource.fetch();

//get the data from Distribution  table. Combine to form the Distribution Info Grid    
    self.getDistributionData();
    
    
        
    
  },
  methods: {
    ...mapActions("postModule",['DeleteItem']),

    getDistributionData: function(){   
      this.DistributionData = this.withFilter(BaseModelDistribution.list);     
    },

    UpdateDistributionMasterData: function (fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.DistributionMasterData = filterMasterData;
      } else {
        this.DistributionMasterData = JSON.parse(JSON.stringify($("#DistributionGrid").data().kendoGrid.dataSource.data()));
      }
    },

    toolbarOnClick: function (e) {
      e.preventDefault();
      switch (e.id) {
        case "btnAddDistribution":
          this.AddDistribution();
          window.$("#BaseModal").modal("toggle");
          break;      
        case "btnBulkImportDistribution":
          // this._AlertPopup("Bulk import screen is in progress...");   
          this.$router.push("/event/distribution/Upload");       
          break;   
        case "btnRefresh":
          this.refreshGrid();
          break;
      }
      this._baseToolBarEvents("DistributionGrid", ...arguments);
    },
    refreshGrid: function(){  
      // console.log("refresh grid Distribution");   
      this.getDistributionData();  
    },
   
    filterGrid: function () {
      let self = this;
      // this.ProgramInfoFormJSON = $("#programGrid").data().kendoGrid.dataSource.view()
      // var displayedData = $("#programGrid").data().kendoGrid.dataSource.view()
      //Then stringify it as follows:
      // var displayedDataAsJSON = JSON.stringify(displayedData); 
      //alert(displayedDataAsJSON );
      var currentMasterdata = this.DistributionMasterData;

      let filteredData = this._filterGrid(this.DistributionMasterData, this.search.SearchData);
      //Filter by a column
      // let filteredData=this._filterGridbyColumn(parentGridData,"StartDate",this.searchData);
      //this.parentdata = filteredData;
      $("#DistributionGrid").data("kendoGrid").dataSource.data(filteredData);
      this.UpdateDistributionMasterData(true, currentMasterdata);
    },
    AddDistribution: function () {
      this.modalConfig.modalName = "Add Distribution";
      this.modalConfig.modalAddorEdit = "add";      
      var DistributionAddJSON = {        
        Id: "",
        PartnerId:"",
        PartnerPartnerID:"",
        PartnerFullName:"",
        ProgramId:"",
        ProgramProgramID:"",
        ProgramTitle:"",
        DistributionType1:"",
        DistributionType2:"",
        DistributionPartnerType:"",
        DistributionDate:"",  
        DistributionAmount:"",
        Note:""
      } ;
      
      this.$refs.DistributionForm.pageErrors=[];
      this.$refs.DistributionForm.ProgramAutoCompleteDisplayedValue="";
      this.$refs.DistributionForm.PartnerAutoCompleteDisplayedValue="";   
      this.$refs.DistributionForm.getProgramAutoCompleteData();
      this.$refs.DistributionForm.getPartnerAutoCompleteData();
      this.DistributionJSON = DistributionAddJSON;
      // this.DistributionAddJSONId = "";          
      // this.$refs.ProgramInfo.$refs.refProgramForm.errors.clear();             
    },
    EditDistribution: function (e) {
      let self = this;
      e.preventDefault();
      this.modalConfig.modalName = "Edit Distribution";
      this.modalConfig.modalAddorEdit = "edit";
      //alert("Edit button clicked from BaseGrid..");  
      var gview = window.$("#DistributionGrid").data("kendoGrid");
      // var dataItem1 = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      var dataItem = JSON.parse(JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr"))));      
      this.$refs.DistributionForm.pageErrors=[];   
      this.$refs.DistributionForm.ProgramAutoCompleteDisplayedValue=dataItem.ProgramTitle;
      this.$refs.DistributionForm.PartnerAutoCompleteDisplayedValue=dataItem.PartnerFullName; 
      this.$refs.DistributionForm.getProgramAutoCompleteData();
      this.$refs.DistributionForm.getPartnerAutoCompleteData();
        //alert(JSON.stringify(dataItem));      
      self.DistributionEditJSON = dataItem;
      self.DistributionJSON = self.DistributionEditJSON;       
      
      window.$("#BaseModal").modal("toggle");

    },
    DeleteItemfromGrid: function (e) {
      e.preventDefault();
      //alert("Delete button clicked from BaseGrid..");
      const message = "Are you sure you want to delete this record?";
      this._ConfirmationPopup(message,"DELETE").then((result) => {
        if (result.value) {
          var gview = window.$("#DistributionGrid").data("kendoGrid");
          var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
          //var dataItem = JSON.stringify(window.$(e.currentTarget).closest("tr"));
          // alert(JSON.stringify(dataItem));
          //Delete Distribution items from the grid                        
          var deleteData = {
            "Id": dataItem.Id
          }
          let items = { list:BaseModelDistribution, payload:deleteData }
          this.DeleteItem(items).then((res) => {
              this.refreshGrid();
            this._AlertPopup("Deleted successfully!","success");
          }).catch(error=>{
              this._AlertPopup("Some Error Occurred!","info");
          })
        }
      });
    },
    DistributionAttachment: function(e) {
      let self = this;
      e.preventDefault();
      const gview = window.$("#DistributionGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedDistribution={...dataItem};
      //TEMP: Only for Transfer Page.. Building Partner Record for the Time Being
      this.selectedDistribution.PartnerTitle=dataItem.PartnerFullName
      this.selectedDistribution.PartnerId=dataItem.PartnerId
      this.selectedDistribution.TransactionID=dataItem.Id
      this.selectedDistribution.BusinessEvent="Distribution"

      //let batchQueryString = this.getBatchGUIDQueryString(this.selectedDistribution.BatchGUID);

      this.filterCondition.batchQuery=false;

      //let BatchGUIDArray=self.GetBatchGUIDArray(this.selectedDistribution.BatchGUID);

      this.filterCondition.filter = `BusinessEvent eq 'Distribution' and TransactionID eq ${
        dataItem.Id }`;

      // this.filterCondition.filter = function(o){
      //   return o.BusinessEvent=='Issuance' & (o.TransactionID == dataItem.Id | BatchGUIDArray.includes(o.BatchGUID))
      // }

      this.$refs.distributionDocument.$refs.distributionDocumentMgr.resetDropZoneGrid();
      window.$("#docModal").modal("toggle");
    },

  },
}
</script>
